module.exports = __webpack_public_path__ + "static/media/maintenance.1556edd7.svg";